import { paths } from 'config'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'

const routes: ModuleRoute[] = [
  {
    path: paths.delegatedAccount,
    admin: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/DelegatedAccount'),
    }),
    layoutSettings: {},
  },
]

export default routes
